import { render, staticRenderFns } from "./FourhSettingsComp.vue?vue&type=template&id=4aa5b60e&"
import script from "./FourhSettingsComp.vue?vue&type=script&lang=js&"
export * from "./FourhSettingsComp.vue?vue&type=script&lang=js&"
import style0 from "./FourhSettingsComp.vue?vue&type=style&index=0&id=4aa5b60e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports